import { gql } from 'urql';

const FetchFlexPayOverTimeOverview = gql`
  query FetchFlexPayOverTimeOverview {
    flexPayOverTimeOverview {
      __typename
      ... on FlexPayOverTimeOverviewSuccess {
        activePlans {
          id
          expiresAt
        }
      }
      ... on FlexPayOverTimeOverviewError {
        code
        title
        message
      }
    }
  }
`;

export default FetchFlexPayOverTimeOverview;
